import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { Link } from 'react-router-dom';
import {setLeadersNav, setOwnerNav, setRole} from '../../../redux/actions/navigation';

import './Sidebar.1.0.scss';

const Sidebar = () =>{
    const dispatch = useDispatch();
    const { ownerNav } = useSelector(({ navigation }) => navigation);
	return (
		<aside className="owner__sidebar">
            <img src="/img/logo.svg" alt="" className="owner__logo"/>
            <div className="owner__nav">
                <div className={`owner__nav-item-active ${ownerNav}`}>
                </div>
                <Link to='/' className='d-flex justify-center'>
                    <div className="owner__nav-item d-flex align-center" onClick={()=>{
                            dispatch(setOwnerNav("Home"))
                            sessionStorage.setItem('ovnerNav', 'Home')
                        }}>
                        <div className={`owner__nav-item-icon home ${(ownerNav === "Home")? "active" : ""}`}></div>
                        <div className="owner__nav-item-title" >Главная</div>
                    </div>
                </Link>
                <Link to='/leaders' className='d-flex justify-center'>
                    <div className="owner__nav-item d-flex align-center" onClick={()=>{
                            dispatch(setOwnerNav("Leaders"))
                            dispatch(setLeadersNav("leaders"))
                            sessionStorage.setItem('ovnerNav', 'Leaders')
                        }}>
                        <div className={`owner__nav-item-icon leaders ${(ownerNav === "Leaders")? "active" : ""}`}></div>
                        <div className="owner__nav-item-title">Руководители</div>
                    </div>
                </Link>
                <Link to='/warehouse' className='d-flex justify-center'>
                    <div className="owner__nav-item d-flex align-center" onClick={()=>{
                            dispatch(setOwnerNav("Warehouse"))
                            sessionStorage.setItem('ovnerNav', 'Warehouse')
                        }}>
                        <div className={`owner__nav-item-icon warehouses ${(ownerNav === "Warehouse")? "active" : ""}`}></div>
                        <div className="owner__nav-item-title">Склады</div> 
                    </div>
                </Link>
            </div> 
            <div className="owner__sidebar-footer">
                <button className="owner__logout d-flex align-center" onClick={()=>{
                    localStorage.setItem('token', '') 
                    localStorage.setItem('role', '')
                    sessionStorage.setItem('token', '') 
                    sessionStorage.setItem('role', '')
                    sessionStorage.setItem('ovnerNav', 'Home')
                    dispatch(setRole(''))  
                }}>
                    <img src="/img/logout.svg" alt="" className="owner__logout-icon"/>
                    <div className="owner__logout-title">Выйти из аккаунта</div>                   
                </button>
            </div>
        </aside>
	)
}

export default Sidebar;